import './components.scss';
import { Link } from "react-router-dom";
import NavigationHeaderItem from './navigationHeaderItem';

const NavigationHeader = (props) => {
  return (
    <div className="navigationHeader">
      <div className='test'>
      <Link to="/" className='navigationHeaderLink'>
      <img src={require("../../images/headerimage.jpg")}></img>
        </Link>
        </div>
      <li>
        <Link to="/" className='navigationHeaderLink'>
        <NavigationHeaderItem name="home"/>
        </Link>
      </li>
      <li>
        <Link to="/shop" className='navigationHeaderLink'>
        <NavigationHeaderItem name="shop"/>
        </Link>
      </li>
      <li>
        <Link to="/about" className='navigationHeaderLink'>
        <NavigationHeaderItem name="about"/>
        </Link>
      </li>
    </div>
  )
}

export default NavigationHeader;